import { Disclosure } from '@headlessui/react';
import styles from './InterestOnlyPaymentsAccordion.module.css';
import { Icon } from '@iwoca/orion';
import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';
import messages from './InterestOnly.messages';
import { FormattedMessage, useIntl } from 'react-intl';
import { DrawdownRepaymentSchedule } from '../../../MyOffers.types';

export const InterestOnlyPaymentsAccordion = ({
    interestOnlyPeriod,
    interestOnlySchedule
}: {
    interestOnlyPeriod: number;
    interestOnlySchedule: DrawdownRepaymentSchedule['schedule'] | null;
}) => {
    const intl = useIntl();

    return (
        <div className={styles.container}>
            <Disclosure>
                {({ open }) => (
                    <>
                        <Disclosure.Button className={styles.accordionButton}>
                            <span className={styles.wrapText}>
                                {intl.formatMessage(
                                    messages.repaymentBreakdownHeading
                                )}
                            </span>
                            <span className={styles.showDetails}>
                                {open
                                    ? intl.formatMessage(
                                          messages.hideDetailsLabel
                                      )
                                    : intl.formatMessage(
                                          messages.showDetailsLabel
                                      )}
                                <Icon
                                    icon={open ? 'angleUp' : 'angleDown'}
                                    className={styles.icon}
                                />
                            </span>
                        </Disclosure.Button>
                        <Disclosure.Panel className={styles.accordionPanel}>
                            <SummaryRow>
                                <span>
                                    {intl.formatMessage(
                                        messages.interestOnlyPeriodLabel
                                    )}
                                </span>
                                <span>
                                    <FormattedMessage
                                        {...messages.interestOnlyPeriodDuration}
                                        values={{
                                            duration: interestOnlyPeriod
                                        }}
                                    />
                                </span>
                            </SummaryRow>

                            {interestOnlySchedule?.map((schedule, index) => (
                                <SummaryRow key={schedule.date}>
                                    <span>
                                        <FormattedMessage
                                            {...messages.monthLabel}
                                            values={{
                                                monthNumber: index + 1
                                            }}
                                        />
                                    </span>
                                    <MoneyWithDecimals value={schedule.total} />
                                </SummaryRow>
                            ))}
                        </Disclosure.Panel>
                    </>
                )}
            </Disclosure>
        </div>
    );
};
